import { useMediaQuery } from 'react-responsive';

import VARS from 'css/export-vars.module.scss';

export default function useIsSoftphoneQuery() {
  const isSoftphone = useMediaQuery({ query: `(max-width: ${VARS.softphoneWidth})` });

  return isSoftphone;
}
